import { Controller } from "@hotwired/stimulus"

// WebMCP: exposes landing-page tools to AI agents via the browser.
// Spec: https://webmachinelearning.github.io/webmcp/
export default class extends Controller {
  static values = {
    locale: { type: String, default: "en" }
  }

  connect() {
    if (!navigator.modelContext || typeof navigator.modelContext.provideContext !== "function") {
      return
    }

    const locale = this.localeValue || "en"

    try {
      navigator.modelContext.provideContext({
        tools: [
          {
            name: "open_pricing",
            description: "Open the FloosYo pricing and product landing page.",
            inputSchema: { type: "object", properties: {}, additionalProperties: false },
            execute: async () => {
              window.location.href = `/${locale}`
              return { ok: true, url: `/${locale}` }
            }
          },
          {
            name: "read_product_info",
            description: "Fetch FloosYo's plain-text product description (llms.txt) describing features, positioning, and differentiators.",
            inputSchema: { type: "object", properties: {}, additionalProperties: false },
            execute: async () => {
              const res = await fetch("/llms.txt", { headers: { Accept: "text/plain" } })
              const text = await res.text()
              return { ok: true, content: text }
            }
          }
        ]
      })
    } catch (error) {
      console.warn("[webmcp] provideContext failed", error)
    }
  }
}
